import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

import Card from '../Card';

export const VotedCard = styled(Card)`
  margin: 30px 0;
`;

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0 20px;
`;

export const VotedCount = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 0 20px;
  color: ${palette('primary')};
  span {
    font-size: 60px;
  }
  small {
    font-size: ${theme('fontSize.xs')};
  }
`;

export const BadgeColumn = styled.span`
  display: inline-block;
  font-size: 10px;
  background-color: ${palette('shareable')};
  color: ${palette('light')};
  padding: 2px 8px;
  border-radius: 10px;
  margin-bottom: ${theme('spacing.md')};
`;

export const CardDescription = styled.div`
  flex: 1;
  justify-content: flex-start;
  padding: 0 30px;
  font-size: ${theme('fontSize.md')};
  color: ${palette('colorBody')};
`;
